import gql from 'graphql-tag'

export const GET_WISHLIST_EVENT = gql`
  query ($limit: Int, $offset: Int, $query: String) {
    event_wishlists(
      offset: $offset
      limit: $limit
      where: {event_schedule: {title: {_ilike: $query}}}
    ) {
      id
      event_schedule {
        id
        type
        category
        title
        slug
        thumbnail
        description
        location_info
        pricing
        datestart
        event_type {
          id
          name
        }
        global_user {
          id
          name
          avatar
        }
      }
    }
  }
`

export const GET_WISHLIST_EVENT_COUNT = gql`
  query ($eventIds: [Int!]) {
    event_wishlists(where: {event_id: {_in: $eventIds}}) {
      id
      event_id
    }
  }
`
